import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminRoute from "./components/AdminRoute";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop"; 
import HomePage from "./pages/HomePage";
import PublicMatchesPage from "./pages/PublicMatchesPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ProfilePage from "./pages/ProfilePage";
import VipPaymentPage from "./pages/VipPaymentPage";

import MatchesPage from "./pages/admin/MatchesPage";
import MatchDetailsPage from "./pages/admin/MatchDetailsPage";
import AdminCouponsPage from "./pages/admin/AdminCouponsPage";
import AdminUsersPage from "./pages/admin/AdminUsersPage";
import AdminPopupList from "./pages/admin/AdminPopupList";
import AdminPopupEditor from "./pages/admin/AdminPopupEditor";
import AdminPopupStats from "./pages/admin/popups/AdminPopupStats";

import PopupManager from "./components/popups/PopupManager";

import VipCompositionsPage from "./pages/vip/VipCompositionsPage";
import SearchPage from "./pages/admin/SearchPage";
import SearchMatchesPage from "./pages/SearchMatchesPage";

import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiesPage from "./pages/CookiesPage";
import ResponsibleGamingPage from "./pages/ResponsibleGamingPage";
import TermsPage from "./pages/TermsPage";

import LegalPage from "./pages/LegalPage";
import Footer from "./components/Footer";

import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

import { useEffect } from "react";
import API from "./services/api";

import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// --- LE TRACKER EST DÉPLACÉ ICI ---
// Ce composant est à l'intérieur du Router, il a le droit d'utiliser useLocation()
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null;
}

function App() {
  // 1. GESTION DU STATUT UTILISATEUR & DU LOGOUT AUTO SI EXPIRÉ
  useEffect(() => {
    const verifyUserStatus = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await API.get("/users/me");
        if (response.data?.success) {
          localStorage.setItem("user", JSON.stringify(response.data.user));
        }
      } catch (error) {
        if (error.response?.status === 401) {
          localStorage.clear();
        }
      }
    };

    verifyUserStatus();
  }, []);

  // 2. RENDU DU ROUTAGE DE L'APPLICATION
  return (
    <BrowserRouter>
      {/* On place le tracker ici, bien enveloppé par BrowserRouter */}
      <AnalyticsTracker />

      <Navbar />
      <PopupManager />    
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/matches" element={<PublicMatchesPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/vip" element={<VipPaymentPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/matches/search" element={<SearchMatchesPage />} />
        <Route path="/match/:id" element={<MatchDetailsPage />} />

        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

        <Route
          path="/admin/users"
          element={
            <AdminRoute>
              <AdminUsersPage />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/popups"
          element={
            <AdminRoute>
              <AdminPopupList />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/popups/new"
          element={
            <AdminRoute>
              <AdminPopupEditor />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/popups/edit/:id"
          element={
            <AdminRoute>
              <AdminPopupEditor />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/popups/stats"
          element={
            <AdminRoute>
              <AdminPopupStats />
            </AdminRoute>
          }
        />

        <Route
          path="/vip/compositions"
          element={<VipCompositionsPage />}
        />

        <Route
          path="/admin"
          element={
            <AdminRoute>
              <MatchesPage />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/compositions"
          element={
            <AdminRoute>
              <AdminCouponsPage />
            </AdminRoute>
          }
        />

        {/* Pages légales */}
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/responsible-gaming" element={<ResponsibleGamingPage />} />
      </Routes>
      
      <Footer />
    </BrowserRouter>
  );
}

export default App;